module.exports = __webpack_public_path__ + "media/images/icons/student-icon-9d3891e2f4236109443838465da972ca.svg";